(() => {
  'use strict';

  const focusableSelector = [
    'a[href]',
    'button:not([disabled])',
    'input:not([disabled]):not([type="hidden"])',
    'select:not([disabled])',
    'textarea:not([disabled])',
    '[tabindex]:not([tabindex="-1"])'
  ].join(',');

  document.querySelectorAll('.im-header').forEach((header) => {
    const toggle = header.querySelector('.im-drawer-toggle');
    const opener = header.querySelector('[data-im-drawer-open]');
    const drawer = header.querySelector('.im-drawer');
    const closer = header.querySelector('[data-im-drawer-close]');
    const scrim = header.querySelector('.im-drawer__scrim');

    if (!toggle || !opener || !drawer || !closer || !scrim) return;

    const syncState = (focusTarget = false) => {
      const open = Boolean(toggle.checked);
      opener.setAttribute('aria-expanded', String(open));
      drawer.setAttribute('aria-hidden', String(!open));
      drawer.inert = !open;
      scrim.style.pointerEvents = open ? 'auto' : 'none';

      if (focusTarget) {
        window.requestAnimationFrame(() => {
          (open ? closer : opener).focus();
        });
      }
    };

    const setOpen = (open, focusTarget = true) => {
      toggle.checked = open;
      syncState(focusTarget);
    };

    const handleKeyboardButton = (event, nextState) => {
      if (event.key !== 'Enter' && event.key !== ' ') return;
      event.preventDefault();
      setOpen(nextState);
    };

    opener.addEventListener('keydown', (event) => {
      handleKeyboardButton(event, !toggle.checked);
    });

    closer.addEventListener('keydown', (event) => {
      handleKeyboardButton(event, false);
    });

    toggle.addEventListener('change', () => syncState(true));

    document.addEventListener('keydown', (event) => {
      if (!toggle.checked) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        setOpen(false);
        return;
      }

      if (event.key !== 'Tab') return;

      const focusable = [...drawer.querySelectorAll(focusableSelector)].filter((element) => {
        return element.getClientRects().length > 0 && element.getAttribute('aria-hidden') !== 'true';
      });

      if (!focusable.length) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener('pageshow', () => {
      setOpen(false, false);
    });

    syncState(false);
  });
})();
